var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "launch",
    class: _vm.isMobile && 'wap'
  }, [_c('p-head'), _c('div', {
    staticClass: "launch-main main",
    class: _vm.isMobile && 'wap'
  }, [_vm._m(0), _c('div', {
    staticClass: "launch-con"
  }, [_c('p-token-from')], 1)])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "launch-hero"
  }, [_c('div', {
    staticClass: "launch-kicker"
  }, [_vm._v("CREATE ON MONAD")]), _c('h1', [_vm._v("Launch your token")]), _c('p', [_vm._v("Set the basics, add your community links, and bring your idea onchain.")])]);
}];
export { render, staticRenderFns };